import * as React from 'react';
import styles from './kycGateError.module.scss';
import { ArrowsClockwise, WarningCircle } from 'phosphor-react';
import { ChildWidgetProps } from '..';

// System-error surface for a KYC gate that could not be evaluated (story
// b.ii.2.3 AC #6 / test case TC-005): GET KYC failed, so the FE cannot tell
// whether this borrower still owes KYC. The form is not rendered and the MLA
// selector is withheld — offering it would let a required KYC be skipped — but
// the rest of the widget still loads and Retry re-runs the gate.
export interface KycGateErrorWidgetProps extends ChildWidgetProps {
  onRetry(): void;
}

export class KycGateErrorWidget extends React.Component<KycGateErrorWidgetProps> {
  constructor(props: KycGateErrorWidgetProps) {
    super(props);
    this.props.widgetStore.setMenuVisibility(true);
  }

  componentDidMount() {
    this.props.onFinished();
  }

  render() {
    return (
      <div className={styles.widget}>
        <div className={styles.content}>
          <p className={styles.title}>
            <WarningCircle className={styles.icon} weight="fill" size={24} /> We
            couldn&apos;t load your verification details
          </p>
          <p className={styles.body}>
            Something went wrong on our end. Please try again in a moment.
          </p>
        </div>
        <div className={styles.footer}>
          <button
            type="button"
            className={`${styles.retryBtn} outlinedBtn`}
            onClick={this.props.onRetry}
          >
            <span className={styles.retryIcon}>
              <ArrowsClockwise size={15} weight="bold" />
            </span>
            Retry
          </button>
        </div>
      </div>
    );
  }
}

export default KycGateErrorWidget;
